/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';
import BaseStore from 'vendor/cnpm/dispatchr.v0-3/addons/index'

export default BaseStore.BaseStore;
